var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.faqs, function(faq, index) {
      return _c(
        "b-collapse",
        {
          key: index,
          staticClass: "card",
          attrs: { open: _vm.isOpen == index },
          on: {
            open: function($event) {
              _vm.isOpen = index
            }
          },
          scopedSlots: _vm._u(
            [
              {
                key: "trigger",
                fn: function(props) {
                  return _c(
                    "div",
                    { staticClass: "card-header", attrs: { role: "button" } },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "card-header-title has-text-weight-medium is-size-5-desktop"
                        },
                        [_vm._v("\n        " + _vm._s(faq.title) + "\n      ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        { staticClass: "card-header-icon" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: props.open ? "menu-down" : "menu-up"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }
              }
            ],
            null,
            true
          )
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "card-content" }, [
            _c("div", {
              staticClass: "content is-medium has-text-weight-light",
              domProps: { innerHTML: _vm._s(faq.text) }
            })
          ])
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }